import styled from 'styled-components';
import { spacing, Body1 } from 'ui/theme';
import { MessageMedium } from 'constants/messageMediums';
import { SummaryInset } from '../summaryInset/SummaryInset';

const BlankWrapper = styled.div`
  padding: ${spacing.base} 0;
`;

export const NoCapSection = ({
  messageMedium,
  isEditing,
}: {
  messageMedium: MessageMedium;
  isEditing: boolean;
}) =>
  isEditing ? (
    <BlankWrapper>
      <Body1>{messageMedium} marketing messages will not be capped by default.</Body1>
    </BlankWrapper>
  ) : (
    <SummaryInset>
      <Body1>{messageMedium} marketing messages will not be capped by default.</Body1>
    </SummaryInset>
  );
